import {
	mdiAccountGroupOutline,
	mdiAccountMultipleOutline,
	mdiAccountTieOutline,
	mdiBookOutline,
	mdiCogOutline,
	mdiDomain,
	mdiLockOutline,
	mdiOfficeBuildingOutline,
	mdiViewDashboardOutline,
} from "@mdi/js";
import { ModuleEntity } from "./defines";

export const screens = [
	{
		module: null,
		name: "Dashboard",
		description: "",
		icon: mdiViewDashboardOutline,
		route: "/dashboard",
		showSidebar: true,
		showDashboard: false,
	},
	{
		module: ModuleEntity.avaliacoes,
		name: "Avaliações",
		description: "Lista de avaliações",
		icon: mdiBookOutline,
		route: "/avaliacoes",
		showSidebar: true,
		showDashboard: true,
	},
	// {
	// 	module: ModuleEntity.avaliacoes,
	// 	name: "Edificações",
	// 	description: "Lista de edificações",
	// 	icon: mdiDomain,
	// 	route: "/edificacoes",
	// 	showSidebar: true,
	// 	showDashboard: true,
	// },
	{
		module: ModuleEntity.configuracoes,
		name: "Configurações",
		description: "Lista de configurações",
		icon: mdiCogOutline,
		route: "/configuracoes",
		showSidebar: true,
		showDashboard: true,
	},
	{
		module: ModuleEntity.acessos,
		name: "Clientes",
		description: "Lista de clientes para gerenciar",
		icon: mdiAccountTieOutline,
		route: "/clientes",
		showSidebar: true,
		showDashboard: true,
	},
	{
		module: ModuleEntity.acessos,
		name: "Acessos",
		description: "",
		icon: mdiLockOutline,
		route: "/acessos",
		showSidebar: true,
		showDashboard: false,
	},
	{
		module: ModuleEntity.acessos,
		name: "Grupos",
		description: "Lista de Grupos de usuários para gerenciar permissões",
		icon: mdiAccountGroupOutline,
		route: "/grupos",
		showSidebar: false,
		showDashboard: true,
	},
	{
		module: ModuleEntity.acessos,
		name: "Usuários",
		description: "Lista de usuários para gerenciar acessos",
		icon: mdiAccountMultipleOutline,
		route: "/usuarios",
		showSidebar: false,
		showDashboard: true,
	},
	{
		module: ModuleEntity.acessos,
		name: "Empresas",
		description: "Lista de empresas para gerenciar",
		icon: mdiOfficeBuildingOutline,
		route: "/empresas",
		showSidebar: false,
		showDashboard: true,
		superUser: true,
	},
];
